<template>
  <Modal v-model="isShowRule2" class="rulesModalBox" @on-cancel="cancelHandle" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <div class="modal-content-wrap">
          <div class="title" v-show="carouselTitle">- <span v-html="carouselTitle"></span> -</div>
          <div class="guide">
            <Carousel loop autoplay :autoplay-speed="5000" dots="outside" radius-dot arrow="always" v-if="isShowCarousel" @on-change="carouselEvent">
              <CarouselItem><img src="@/assets/images/query/s1.png"></CarouselItem>
              <CarouselItem><img src="@/assets/images/query/s2.png"></CarouselItem>
              <CarouselItem><img src="@/assets/images/query/s3.png"></CarouselItem>
              <CarouselItem><img src="@/assets/images/query/6.png"></CarouselItem>
              <!--<CarouselItem><img src="@/assets/images/query/3.png"></CarouselItem>-->
            </Carousel>
          </div>
          <div class="footer">
            <div class="footer-wrap clearfix">
              <div class="btn" @click.prevent="cancelHandle">我知道了</div>
              <Checkbox v-model="instructionSwitch">不再提醒</Checkbox>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
</template>

<script>
import { mapState, mapMutations, createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'ChargesModalZH',
  props: {
    isShowRule: {
      type: Boolean,
      default: false,
      required: false
    },
    isAutoShow: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      isShowCarousel: false,
      carouselTitle: null,
      isShowRule2: false,
      oldInstructionSwitch: null
    }
  },
  computed: {
    instructionSwitch: {
      get () {
        return this.userSettting.instructionSwitch === 0
      },
      set (v) {
        if (this.oldInstructionSwitch === null) {
          this.oldInstructionSwitch = v ? 1 : 0
        }
        this.setSettings({
          type: 2, data: v ? 0 : 1
        })
      }
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        // return (key) => 0
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapState('account', {
      userSettting: state => state.settting
    }),
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  mounted () {
    this.$nextTick(() => {
      if (this.instructionSwitch) {
        this.$emit('ruleModalState', false)
      } else {
        if (this.isAutoShow) {
          this.$emit('ruleModalState', true)
        }
      }
    })
  },
  watch: {
    isShowRule (newVal, oldVal) {
      this.isShowRule2 = newVal
      if (newVal) {
        setTimeout(() => {
          // let jd = this.apiPrice ? this.apiPrice(1).integral : null
          // this.carouselTitle = jd === null ? '税率查询' : (jd > 0 ? `税率查询将消费${jd}个积点` : '税率查询 <span style="color:#1F8AFD;">限时免费</span>')
          this.carouselTitle = '税率查询 1积点/次<span style="color:#1F8AFD;display: none;">（限时免费）</span>'
          this.isShowCarousel = true
        }, 300)
      } else {
        this.isShowCarousel = false
      }
    }
  },
  methods: {
    carouselEvent (oldValue, value) {
      // let jd = this.apiPrice ? this.apiPrice(1).integral : null
      switch (value) {
        case 0:
          this.carouselTitle = '税率查询 1积点/次<span style="color:#1F8AFD;display: none;">（限时免费）</span>'
          break
        case 1:
          this.carouselTitle = '原产地查询 50积点/次'
          break
        case 2:
          // this.carouselTitle = jd === null ? '税率查询' : (jd > 0 ? `税率查询将消费${jd}个积点` : '税率查询 <span style="color:#1F8AFD;">限时免费</span>')
          this.carouselTitle = '税则查询 1积点/次<span style="color:#1F8AFD;display: none;">（限时免费）</span>'
          break
        case 3:
          // jd = this.apiPrice ? this.apiPrice(2).integral : null
          // this.carouselTitle = jd === null ? '原产地查询' : (jd > 0 ? `原产地查询将消费${jd}个积点` : '原产地查询 <span style="color:#1F8AFD;">（限时免费）</span>')
          this.carouselTitle = '13位商品编码查询/中美加征速查 1积点/次'
          break
        // case 4:
        //   jd = this.apiPrice ? this.apiPrice(3).integral : null
        //   this.carouselTitle = jd === null ? '税则查询' : (jd > 0 ? `税则查询将消费${jd}个积点` : '税则查询 <span style="color:#1F8AFD;">限时免费</span>')
        //   break
      }
    },
    cancelHandle (event) {
      if (this.oldInstructionSwitch !== this.userSettting.instructionSwitch) {
        this.$api.account.member.setting.set({
          instructionSwitch: this.userSettting.instructionSwitch
        }, {})
      }
      this.$emit('ruleModalState', false)
    },
    ...mapMutations({
      setSettings: 'account/setSettingState'
    }),
    ...mapDataGetters(['getApiValue'])
  }
}
</script>
<style>
  @media print,screen and (min-width:1366px) {
    .rulesModalBox .vertical-center-modal,
    .rulesModalBox .ivu-modal{
      width: 540px !important;
      margin: 0 auto;
    }
  }
  @media print,screen and (max-width:1365px) {
    .rulesModalBox .vertical-center-modal,
    .rulesModalBox .ivu-modal{
      width: 540px !important;
      margin: 0 auto;
    }
  }
  .rulesModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -100px;
  }
  .rulesModalBox .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .rulesModalBox .ivu-modal-header,
  .rulesModalBox .ivu-modal-footer{
    display: none;
  }
  .rulesModalBox .ivu-modal-close{
    display: none;
  }
  .rulesModalBox .modal-content-wrap .title{
    text-align: center;
    font-size: 15px;
    color: #333;
    margin: 5px 0 12px;
  }
  .rulesModalBox .guide img {
    width: 100%;
  }
  /* .rulesModalBox .ivu-carousel-item img{
    width: 893px;
    height: 435px;
  } */
  .rulesModalBox .footer{
    margin: 20px 0 5px;
  }
  .rulesModalBox .footer .footer-wrap{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rulesModalBox .footer .btn{
    background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%);
    border-radius: 3px;
    font-size: 13px;
    color: #fff;
    height: 32px;
    line-height: 32px;
    width: 120px;
    text-align: center;
    float: left;
    cursor: pointer;
  }
  .rulesModalBox .footer .ivu-checkbox-wrapper{
    font-size: 12px;
    color: #999;
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/ChargesModal.vue